import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Hub from './Hub';
import Quicksight from './Quicksight';
import PowerBI from './PowerBI';
import StaticMockup from './StaticMockup';
import DataStudio from './DataStudio';

function AnalyticsRouter() {
  return (
    <Routes>
      <Route path="/" element={<Hub />} />
      <Route path="/qs" element={<Quicksight />} />
      <Route path="/pbi" element={<PowerBI />} />
      <Route path="/ds" element={<DataStudio />} />
      <Route path="/static" element={<StaticMockup />} />
    </Routes>
  );
}

export default AnalyticsRouter;
